import React, { useReducer, useCallback, useState, useEffect } from "react";
import { Link, withPrefix } from "gatsby";
import styled from "styled-components";
import logo from "../../img/logo.png";

import NavbarCoursePulldown from "./NavbarCoursePulldown";
import NavbarSpecialPulldown from "./NavbarSpecialPulldown";
import NavbarBeginnerPulldown from "./NavbarBeginnerPulldown";

const HOVER_DELAY = 40;
const NAVBAR_HEIGHT = 85;
const NAVBAR_HEIGHT_SMALL = 70;

const pulldownReducer = (state, action) => {
  switch (action.type) {
    case "SET_PULLDOWN":
      return {
        ...state,
        pulldownActive: true,
        pulldownEnglish: action.menu === "english",
        pulldownCourse: action.menu === "course",
        pulldownSpecial: action.menu === "special",
        pulldownBeginner: action.menu === "beginner",
      };
    case "CLOSE":
      return {
        pulldownActive: false,
        pulldownEnglish: false,
        pulldownCourse: false,
        pulldownSpecial: false,
        pulldownBeginner: false,
      };
    default:
      return state;
  }
};

const NavbarDesktop = () => {
  const [pulldownState, dispatch] = useReducer(pulldownReducer, {
    pulldownActive: false,
    pulldownCourse: false,
    pulldownSpecial: false,
    pulldownBeginner: false,
  });

  const [hoverTimer, setHoverTimer] = useState(null);

  const handleMouseEnter = useCallback(
    (menu) => {
      if (hoverTimer) {
        clearTimeout(hoverTimer);
      }

      const timer = setTimeout(() => {
        dispatch({ type: "SET_PULLDOWN", menu });
      }, HOVER_DELAY);

      setHoverTimer(timer);
    },
    [hoverTimer]
  );

  const handleMouseLeave = useCallback(() => {
    if (hoverTimer) {
      clearTimeout(hoverTimer);
    }

    const timer = setTimeout(() => {
      dispatch({ type: "CLOSE" });
    }, HOVER_DELAY);

    setHoverTimer(timer);
  }, [hoverTimer]);

  useEffect(() => {
    return () => {
      if (hoverTimer) {
        clearTimeout(hoverTimer);
      }
    };
  }, [hoverTimer]);

  return (
    <div className="is-hidden-touch">
      <NavGroup>
        <LogoContainer>
          <LogoSection to="/">
            <LogoImage src={logo} alt="NUOCW" />
          </LogoSection>
          <DummyContainer>
            <DummyInner>
              <DummyText> </DummyText>
              <DummyDivider> </DummyDivider>
              <DummyText> </DummyText>
            </DummyInner>
          </DummyContainer>
        </LogoContainer>
        <PulldownSection>
          <div id="navMenu" className="navbar-menu" style={{ height: "100%" }}>
            {pulldownState.pulldownActive && (
              <PulldownActive onMouseLeave={handleMouseLeave} />
            )}
            <div className="navbar-end">
              <PulldownItem onMouseLeave={handleMouseLeave}>
                <PulldownLink
                  className={`${
                    pulldownState.pulldownCourse
                      ? "on-pulldown"
                      : "off-pulldown"
                  }`}
                  onMouseEnter={() => handleMouseEnter("course")}
                >
                  授業を探す
                </PulldownLink>
                <div
                  className={`${
                    pulldownState.pulldownCourse
                      ? "is-pulldown"
                      : "not-pulldown"
                  }`}
                >
                  <NavbarCoursePulldown />
                </div>
              </PulldownItem>
              <PulldownItem onMouseLeave={handleMouseLeave}>
                <PulldownLink
                  className={`${
                    pulldownState.pulldownSpecial
                      ? "on-pulldown"
                      : "off-pulldown"
                  }`}
                  onMouseEnter={() => handleMouseEnter("special")}
                >
                  特集記事
                </PulldownLink>
                <div
                  className={`${
                    pulldownState.pulldownSpecial
                      ? "is-pulldown"
                      : "not-pulldown"
                  }`}
                >
                  <NavbarSpecialPulldown />
                </div>
              </PulldownItem>

              <PulldownItem onMouseLeave={handleMouseLeave}>
                <PulldownLink
                  className={`${
                    pulldownState.pulldownBeginner
                      ? "on-pulldown"
                      : "off-pulldown"
                  }`}
                  onMouseEnter={() => handleMouseEnter("beginner")}
                >
                  初めての方へ
                </PulldownLink>
                <div
                  className={`${
                    pulldownState.pulldownBeginner
                      ? "is-pulldown"
                      : "not-pulldown"
                  }`}
                >
                  <NavbarBeginnerPulldown />
                </div>
              </PulldownItem>

              <PulldownItem>
                <Link to="/mylist">
                  <NavbarLink>マイリスト</NavbarLink>
                </Link>
              </PulldownItem>
            </div>
          </div>
        </PulldownSection>
        <LinkSearchSection>
          <NavbarSub role="navigation" aria-label="sub-navigation">
            <div
              className="container"
              style={{ gap: "0px", textAlign: "center" }}
            >
              <div style={{ justifyContent: "center" }}>
                <StyledLink to="/form">お問い合わせ</StyledLink>
                <StyledLink to="/forteacher">教員の方へ</StyledLink>
                <StyledLink to="/links">リンク集</StyledLink>
              </div>
              <PulldownItem style={{ height: "50px" }}>
                <SearchContainer className="field has-addons">
                  <div className="control">
                    <input
                      className="input is-rounded"
                      id="keyword"
                      type="text"
                      style={{ fontSize: "0.8rem," }}
                      placeholder="検索したい単語を入力…"
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                          let params = {
                            keyword: document.getElementById("keyword").value,
                          };
                          const urlSearchParam = new URLSearchParams(
                            params
                          ).toString();
                          document.location.href = `${withPrefix(
                            "/search?"
                          )}${urlSearchParam}`;
                        }
                      }}
                    />
                  </div>
                  <div className="control">
                    <SearchButton
                      className="input is-rounded"
                      type="button"
                      value="検索"
                      onClick={(e) => {
                        e.preventDefault();
                        let params = {
                          keyword: document.getElementById("keyword").value,
                        };
                        const urlSearchParam = new URLSearchParams(
                          params
                        ).toString();
                        document.location.href = `${withPrefix(
                          "/search?"
                        )}${urlSearchParam}`;
                      }}
                    />
                  </div>
                </SearchContainer>
              </PulldownItem>
            </div>
          </NavbarSub>
        </LinkSearchSection>
      </NavGroup>
    </div>
  );
};

const NavGroup = styled.div`
  display: flex;
  flex-direction: row;
  background-color: #323232;
  justify-content: space-between;

  @media (max-width: 1300px) {
    font-size: 0.9rem;
  }
`;

const DummyContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 0 1rem;
  height: ${NAVBAR_HEIGHT}px;
  background-color: #323232;

  @media (max-width: 1300px) {
    height: ${NAVBAR_HEIGHT_SMALL}px;
  }
`;

const DummyInner = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 90px;
  font-size: 1.1rem;

  @media (max-width: 1300px) {
    width: 80px;
    font-size: 1rem;
  }
`;

const DummyText = styled.span`
  color: #ffffff;
  font-weight: 500;
  width: 32px;
  text-align: center;
`;

const DummyDivider = styled.span`
  color: #9ca3af;
`;

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
`;

const LogoSection = styled(Link)`
  padding: 0;
  width: 180px;
  background-color: white;
  height: ${NAVBAR_HEIGHT}px;
  display: flex;
  align-items: center;
  text-decoration: none;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #f8f8f8;
  }

  @media (max-width: 1300px) {
    width: 150px;
    height: ${NAVBAR_HEIGHT_SMALL}px;
  }
`;

const LogoImage = styled.img`
  padding: 0.5rem;
  background: #006649;
  height: ${NAVBAR_HEIGHT}px;
  width: auto;
  transition: background-color 0.3s ease;

  ${LogoSection}:hover & {
    background: rgb(24, 147, 112);
  }

  @media (max-width: 1300px) {
    height: ${NAVBAR_HEIGHT_SMALL}px;
  }
`;

const PulldownSection = styled.nav`
  width: auto;
  height: ${NAVBAR_HEIGHT}px;
  z-index: 30;
  background-color: #323232;
  display: flex;
  align-items: center;

  .navbar-start {
    height: ${NAVBAR_HEIGHT}px;
    display: flex;
    align-items: center;
    padding-left: 0.7rem;
  }

  @media (max-width: 1300px) {
    height: ${NAVBAR_HEIGHT_SMALL}px;

    .navbar-start {
      height: ${NAVBAR_HEIGHT_SMALL}px;
    }
  }
`;

const LinkSearchSection = styled.div`
  width: 340px;
  height: 100%;
  z-index: 29;
  background-color: hsl(0, 0%, 19.6%);
  @media (max-width: 1300px) {
    width: 280px;
  }
`;

const NavbarSub = styled.nav`
  height: ${NAVBAR_HEIGHT}px;
  width: 100%;
  position: relative;
  z-index: 30;
  font-size: 0.8em;
  display: flex;
  align-items: center;

  div.container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 0.5rem;
    width: 100%;
    padding: 0 1rem;

    > div:first-child {
      display: flex;
      justify-content: flex-end;
      gap: 1rem;

      @media (max-width: 1300px) {
        gap: 0.5rem;
      }
    }
  }

  @media (max-width: 1300px) {
    height: ${NAVBAR_HEIGHT_SMALL}px;
    width: 100%;

    div.container {
      padding: 0;
    }
  }
`;

const SearchButton = styled.input`
  background-color: rgb(186, 186, 186);
  color: white;
  :hover {
    background-color: rgb(147, 147, 147);
    color: white;
    cursor: pointer;
  }
`;

const PulldownActive = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 0;
  display: block;
  cursor: default;
  content: " ";
  background: transparent;
`;

const PulldownItem = styled.div`
  display: flex;
  align-items: center;
  flex-grow: 0;
  flex-shrink: 0;
  line-height: 1.5;
  padding: 1.5rem 0.5rem;
  position: relative;
  height: ${NAVBAR_HEIGHT}px;
  transition: 0.2s cubic-bezier(0.45, 0, 0.55, 1);

  div.off-pulldown {
    color: #ffffff;
  }
  div.on-pulldown {
    color: rgb(255, 255, 255);
  }
  a:hover,
  div.on-pulldown:hover {
    color: rgb(215, 215, 215); // ホバー時に文字色を変更
  }
  div.is-pulldown {
    background-color: black;
    padding-bottom: 0.5rem;
    padding-top: 0.5rem;
    box-shadow: 0 8px 8px rgba(43, 37, 35, 0.1);
    font-size: 0.875rem;
    left: 0;
    position: absolute;
    min-width: 100%;
    top: 100%;
    z-index: 20;
    display: block;
    opacity: 0.9;
  }
  div.not-pulldown {
    display: none;
  }
  div.is-pulldown {
    font-size: 0.875rem;
    position: fixed;
    top: 5.3rem;
    z-index: 20;
    display: block;
    div.container {
      padding-bottom: 0.5rem;
      padding-top: 0.5rem;
      border-radius: 1rem;
      border-top: none;
    }
    div.not-pulldown {
      display: none;
    }
  }

  @media (max-width: 1300px) {
    height: ${NAVBAR_HEIGHT_SMALL}px;
  }

  div.is-pulldown {
    @media (max-width: 1300px) {
      top: 4.3rem;
    }
  }
`;

const SearchContainer = styled.div`
  @media (max-width: 1300px) {
    input {
      font-size: 0.9rem;
    }
    input::placeholder {
      font-size: 0.9rem;
    }
  }
`;

const NavbarLink = styled.div`
  font-size: 1rem; // フォントサイズを少し小さく
  align-items: center;
  display: flex;
  cursor: pointer;
  color: #ffffff;
  line-height: 1.5;
  padding: 0.5rem 0.75rem;
  position: relative;
  border-radius: 0.5rem;

  :hover {
    color: rgb(215, 215, 215); // ホバー時に文字色を変更
  }

  @media (max-width: 1300px) {
    font-size: 0.9rem; // モバイル時も少し小さく
    padding: 0.4rem 0.6rem;
  }
`;

const PulldownLink = styled(NavbarLink)`
  padding: 0.5rem 2.2em 0.5rem 0.75rem;
  margin-right: 0rem;
  font-size: 1rem; // フォントサイズを少し小さく

  ::after {
    border: 3px solid;
    border-color: #3273dc;
    margin-top: -0.375em;
    right: 1.125em;
    border-radius: 2px;
    border-right: 0;
    border-top: 0;
    content: " ";
    display: block;
    height: 0.625em;
    margin-top: -0.4375em;
    pointer-events: none;
    position: absolute;
    top: 50%;
    transform: rotate(-45deg);
    transform-origin: center;
    width: 0.625em;
    @media (max-width: 1300px) {
      right: 0.8em;
    }
  }

  @media (max-width: 1300px) {
    font-size: 0.9rem; // モバイル時も少し小さく
    padding: 0.4rem 1.8em 0.4rem 0.6rem;
  }
`;

const StyledLink = styled(Link)`
  font-size: 0.85rem;
  color: white;
  position: relative;
  padding-left: 0.8rem;
  text-decoration: none;
  transition: color 0.2s ease;

  &:hover {
    color: rgb(180, 180, 180);
  }

  &::before {
    position: absolute;
    content: "";
    width: 0;
    height: 0;
    border: solid 0.5rem transparent;
    border-left: solid 0.5rem #697b91;
    top: 0.1rem;
    left: 0;

    @media (max-width: 1300px) {
      border: solid 0.4rem transparent;
      border-left: solid 0.4rem #697b91;
    }
  }

  @media (max-width: 1300px) {
    font-size: 0.75rem;
  }
`;

export default NavbarDesktop;
